var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _rect, _path2, _circle2, _circle3, _path3, _circle4, _circle5, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg403 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 318,
  height: 318,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 159,
  r: 159,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7FC",
  d: "M98.402 254c-15.367 0-22.684 3.441-15.81 7.647s30.317 4.206 36.547 4.206 25.749-1.912 37.792-2.294S174.789 267 193.063 267s17.858-3.441 24.503-5.353 22.841.382 22.426-3.441c-.332-3.059-6.506-4.079-9.552-4.206z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M214.5 140.5c13 2.5 12.5 42 12.5 54"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M188 207.5c5.5 20 4.5 21.5 6.5 39"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BABEDE",
  d: "M178 251.909c0-5.472 4.437-9.909 9.909-9.909h17.342c5.473 0 9.909 4.437 9.909 9.909a2.477 2.477 0 0 1-2.477 2.478h-32.206a2.477 2.477 0 0 1-2.477-2.478"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M165 209c-3 16.5-3.5 26.5-6 36.281"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M141.5 138c-19.5-5-12.5 55-39 15"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__f)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 98.586,
  height: 98.586,
  x: 132.829,
  y: 113,
  fill: "#BABEDE",
  rx: 49.293,
  transform: "rotate(6.892 132.829 113)"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BABEDE",
  d: "M137 251.909c0-5.472 4.437-9.909 9.909-9.909h17.342c5.473 0 9.909 4.437 9.909 9.909a2.477 2.477 0 0 1-2.477 2.478h-32.206a2.477 2.477 0 0 1-2.477-2.478"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__h)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 227,
  cy: 201,
  r: 8,
  fill: "#BABEDE"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__i)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 151,
  r: 8,
  fill: "#BABEDE"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M176 122.5V104"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__k)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.465,
  height: 18.131,
  x: 140,
  y: 73,
  fill: "#BABEDE",
  rx: 6.232
}))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#403_svg__l)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 63.458,
  height: 58.925,
  x: 144.667,
  y: 54,
  fill: "#BABEDE",
  rx: 29.462
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12.465,
  height: 18.131,
  x: 200,
  y: 73,
  fill: "#BABEDE",
  rx: 6.232
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#223",
  d: "M152 84.332C152 78.073 157.073 73 163.332 73h24.929c6.259 0 11.332 5.073 11.332 11.332 0 6.258-5.073 11.331-11.332 11.331h-24.929c-6.259 0-11.332-5.073-11.332-11.331"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.332,
  cy: 84.331,
  r: 5.666,
  fill: "#E9EBF5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.262,
  cy: 84.332,
  r: 5.666,
  fill: "#E9EBF5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#594D6B",
  d: "M96.88 93.174h5v87.5a2.5 2.5 0 0 1-5 0z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.5,
  cy: 88.5,
  r: 38.5,
  fill: "#E9EBF5"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.38,
  cy: 88.674,
  r: 21.5,
  stroke: "#594D6B",
  strokeWidth: 4
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#594D6B",
  d: "m83.263 74.886 2.829-2.829 30.405 30.406-2.828 2.828z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__a",
  width: 18.503,
  height: 60.001,
  x: 211.5,
  y: 137.499,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__b",
  width: 12.501,
  height: 45.001,
  x: 184.999,
  y: 204.499,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__c",
  width: 37.16,
  height: 12.387,
  x: 178,
  y: 242,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__d",
  width: 12.001,
  height: 42.283,
  x: 155.999,
  y: 206,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__e",
  width: 45.001,
  height: 35.128,
  x: 99.5,
  y: 134.702,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__f",
  width: 98.596,
  height: 98.596,
  x: 126.554,
  y: 118.554,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_167_1024"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 8,
  dy: -18
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__g",
  width: 37.16,
  height: 12.387,
  x: 137,
  y: 242,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__h",
  width: 16,
  height: 16,
  x: 219,
  y: 193,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__i",
  width: 16,
  height: 16,
  x: 92,
  y: 143,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__j",
  width: 6,
  height: 24.5,
  x: 173,
  y: 101,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__k",
  width: 12.465,
  height: 18.131,
  x: 140,
  y: 73,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1,
  dy: -2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})), /*#__PURE__*/React.createElement("filter", {
  id: "403_svg__l",
  width: 63.458,
  height: 58.925,
  x: 144.667,
  y: 54,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_167_1024"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 11,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_167_1024"
})))));
export default Svg403;